import React from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import http from 'app/http';
import { setContent } from 'features/content/reducer';
import { useAppDispatch } from 'app/hooks';
import qs from 'qs';
import PageLink from 'components/PageLink/PageLink';
interface Props {
  PageData?: any;
  Model?: any;
  instalmentValue: any;
  setShowEditDisposablePopup?: any;
}

const Editposibleincome = ({
  PageData,
  Model,
  instalmentValue,
  setShowEditDisposablePopup,
}: Props) => {
  let history = useHistory();
  const dispatch = useAppDispatch();
  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);

    return link.pathname + link.search;
  };
  const pathurl = getPathnameFromUrl(Model.ChangeDisposableIncomeUrl);

  const editDisposableOnClick = async (e: any) => {
    e.preventDefault();
    try {
      const response = await http.post(
        pathurl,
        // Convert object into string
        qs.stringify({
          selectedAmount: instalmentValue,
        }),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        },
      );
      if (response && response.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
        var nextPagePath = '';
        if (!response.data.data) {
          nextPagePath = pathurl;
          dispatch(setContent({ [nextPagePath]: response.data }));
        } else {
          nextPagePath = getPathnameFromUrl(response.data.data);
          setShowEditDisposablePopup(true);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div className="Grid Grid--gutterH Grid--white GridWhite--smFull u-marginBz">
      <div className="Grid-cell">
        <div className="Editdisposibleincome Editdisposibleincome-block">
          <p>{PageData?.DisposableIncomeHeading}</p>
          <span
            className="Editdisposibleincome-highligt"
            dangerouslySetInnerHTML={{ __html: Model?.DisposableIncome }}
          />

          <button
            type="button"
            className="Button Button--ghost Button--small "
            onClick={editDisposableOnClick}
          >
            <span>{PageData?.DisposableIncomeEditBtnLabel}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Editposibleincome;
